<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        color="primary"
        dark
        v-on="on"
      >
        <v-icon>language</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        v-for="(lcl) in locales"
        :key="lcl.key"
        @click="setLocale(lcl.key)"
      >
        <v-list-tile-title>{{ lcl.display }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'LocalePicker',
  data: () => ({
    selectedLocale: 'en',
    locales: [
      { key: 'en', display: 'EN' },
      { key: 'ee', display: 'EE' },
      { key: 'pl', display: 'PL' }
    ]
  }),
  methods: {
    setLocale (lclKey) {
      window.localStorage.setItem('locale', lclKey)
      window.location.reload()
      this.$i18n.locale = lclKey
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LocalePicker.vue